/* Modulo Drop Banner — countdown timer.
   Vanilla IIFE, lazy-init, server-rendered initial values (no CLS). */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  function pad2(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function initSection(el) {
    var endAttr = el.getAttribute('data-end-ms');
    var endMs = endAttr ? parseInt(endAttr, 10) : 0;
    var onComplete = el.getAttribute('data-on-complete') || 'show-message';
    var timer = el.querySelector('[data-modulo-bd-timer]');
    var timerWrap = el.querySelector('[data-modulo-bd-timer-wrap]');
    if (!timer || !endMs) return;

    var daysEl    = timer.querySelector('[data-unit="days"]');
    var hoursEl   = timer.querySelector('[data-unit="hours"]');
    var minutesEl = timer.querySelector('[data-unit="minutes"]');
    var secondsEl = timer.querySelector('[data-unit="seconds"]');

    var interval = null;

    function render(diffMs) {
      var diff = Math.max(0, Math.floor(diffMs / 1000));
      var days = Math.floor(diff / 86400);
      var hrs  = Math.floor((diff % 86400) / 3600);
      var mins = Math.floor((diff % 3600) / 60);
      var secs = diff % 60;
      if (daysEl)    daysEl.textContent    = String(days);
      if (hoursEl)   hoursEl.textContent   = pad2(hrs);
      if (minutesEl) minutesEl.textContent = pad2(mins);
      if (secondsEl) secondsEl.textContent = pad2(secs);
    }

    function complete() {
      el.setAttribute('data-ended', 'true');
      if (onComplete === 'hide-timer' && timerWrap && timerWrap.parentNode) {
        timerWrap.parentNode.removeChild(timerWrap);
      } else if (onComplete === 'hide-section' && el.parentNode) {
        el.parentNode.removeChild(el);
      }
      // show-message is handled by CSS via [data-ended="true"].
    }

    // Liquid already rendered the ended state — run completion on load too.
    if (el.getAttribute('data-ended') === 'true') {
      complete();
      return;
    }

    if (endMs - Date.now() <= 0) {
      render(0);
      complete();
      return;
    }

    render(endMs - Date.now());
    interval = setInterval(function () {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        render(0);
        clearInterval(interval);
        interval = null;
        complete();
        return;
      }
      render(diff);
    }, 1000);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-bd]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-bd]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
